<app-header [showEnvWarning]="showEnvWarning"></app-header>
<div class="container-fluid">
    <div class="row">
        <div class="nav">
            <app-navigation></app-navigation>
        </div>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>